import { PropertyMeldConnectForm } from './PropertyMeldConnectForm'
import type { VendorConnectorProps } from './types'

export function PropertyMeldConnector({ onConnected }: VendorConnectorProps) {
  return <PropertyMeldConnectForm onConnected={() => onConnected?.()} />
}
